module.exports = {"420115001":"纸坊街道","420115002":"金口街道","420115003":"乌龙泉街道","420115005":"郑店街道","420115007":"五里界街道","420115008":"金水","420115009":"安山街道","420115010":"山坡街道","420115014":"法泗街道","420115015":"湖泗街道","420115016":"舒安街道","420115086":"佛祖岭街道","420115087":"豹澥街道","420115088":"龙泉街道","420115089":"滨湖街道","420115401":"武汉江夏经济开发区庙山高新技术产业园","420115402":"武汉江夏经济开发区藏龙岛高新技术产业园","420115403":"武汉江夏经济开发区大桥现代产业园","420115404":"江夏区经济开发区梁子湖风景区办事","420115405":"武汉江夏经济开发区金港汽车产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420115.json
// module id = 1708
// module chunks = 0